import { useMappedPropsOptions } from "./component-library134.mjs";
import Heading from "./component-library6.mjs";
import Badge from "./component-library31.mjs";
import GridContainer from "./component-library25.mjs";
import GridRow from "./component-library26.mjs";
import GridColumn from "./component-library27.mjs";
import "./component-library135.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "ImageTextGridRow",
  components: {
    GridColumn,
    GridRow,
    GridContainer,
    Heading,
    Badge
  },
  mixins: [
    useMappedPropsOptions(Heading, "heading", {
      tag: "h2"
    })
  ],
  props: {
    imageAlignment: {
      type: String,
      default: "left",
      validator: (value) => ["left", "right"].includes(value)
    },
    badgePosition: {
      type: Object,
      default: () => ({
        top: -75,
        right: "20%"
      })
    },
    badgePositionMobile: {
      type: Object,
      default: () => ({
        top: -50,
        right: 20
      })
    }
  },
  computed: {
    imageOrder() {
      return this.imageAlignment === "left" ? "first" : "last";
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("grid-container", { staticClass: "image-text-grid-row", class: `image-text-grid-row--order-image-${_vm.imageOrder}`, attrs: { "is-fluid": "" } }, [_c("grid-row", { staticClass: "image-text-grid-row__columns" }, [_c("grid-column", { staticClass: "image-text-grid-row__column-image", class: `image-text-grid-row__column-image--order-${_vm.imageOrder}`, attrs: { "xs": 12, "md": 8, "lg": 9 } }, [_c("div", { staticClass: "image-text-grid-row__image" }, [_vm._t("image"), _vm.$slots.badge ? _c("badge", { staticClass: "image-text-grid-row__badge", style: {
    "--badge-xs-padding": "1em",
    "--badge-sm-padding": "1em"
  }, attrs: { "position-default": _vm.badgePosition, "position-mobile": _vm.badgePositionMobile, "default-font-size": 28, "mobile-font-size": 20, "mobile-breakpoint": "lg", "data-testid": "badge" } }, [_vm._t("badge")], 2) : _vm._e()], 2)]), _c("grid-column", { staticClass: "image-text-grid-row__column-content", attrs: { "xs": 12, "md": 4, "lg": 3 } }, [_vm.$slots.topline ? _c("heading", { staticClass: "image-text-grid-row__topline", attrs: { "tag": "strong", "size": "xs", "data-testid": "topline" } }, [_vm._t("topline")], 2) : _vm._e(), _vm._t("headingContainer", function() {
    return [_c("heading", _vm._b({ staticClass: "image-text-grid-row__heading", attrs: { "data-testid": "heading" } }, "heading", _vm.mappedHeadingProps, false), [_vm._t("heading")], 2)];
  }), _c("div", { staticClass: "image-text-grid-row__copy", attrs: { "data-testid": "copy" } }, [_vm._t("copy")], 2)], 2)], 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "3f330794",
  null,
  null
);
const imageTextGridRow = __component__.exports;
export {
  imageTextGridRow as default
};
